<template>
  <div class="wrapper">
    <div id="javascriptComponents">
      <div class="md-layout">
        <div class="md-layout-item mx-auto md-small-size-100 md-size-100">
          <md-card class="md-small-size-100 md-size-100">
            <carousel
              :perPage="1"
              :loop="true"
              :speed="700"
              :autoplay="true"
              :autoplayTimeout="5000"
              :mouseDrag="false"
              :touchDrag="false"
              :adjustableHeight="true"
              navigationEnabled
              navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
              navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>"
            >
              <slide>
                <div class="carousel-caption">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <div class="image-wrapper">
                        <div class="brand">
                          <h1><b>D</b>ays<b> I</b>nn <b>S</b>herman</h1>
                          <h3>Hotel & Banquet Halls</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4>
                    <md-icon>location_on</md-icon>
                    3605 US-75, Sherman, TX, United States
                  </h4>
                </div>
                <img :src="carousel1" alt="carousel1" />
              </slide>
              <slide>
                <div class="carousel-caption">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <div class="image-wrapper">
                        <div class="brand">
                          <h1><b>O</b>RANGE<b>T</b>REE</h1>
                          <h3>Bar and Restaurant</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4>
                    <md-icon>location_on</md-icon>
                    3605 US-75, Sherman, TX, United States
                  </h4>
                </div>
                <img :src="carousel2" alt="carousel2" />
              </slide>
              <slide>
                <div class="carousel-caption">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <div class="image-wrapper">
                        <div class="brand">
                          <h1><b>D</b>ays<b> I</b>nn <b>S</b>herman</h1>
                          <h3>Hotel & Banquet Halls</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4>
                    <md-icon>location_on</md-icon>
                    3605 US-75, Sherman, TX, United States
                  </h4>
                </div>
                <img :src="carousel3" alt="carousel3" />
              </slide>
            </carousel>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JavascriptComponents',
  data() {
    return {
      carousel1: require("@/assets/img/slider_img1.jpg"),
      carousel2: require("@/assets/img/slider_img2.jpg"),
      carousel3: require("@/assets/img/slider_img3.jpg")
    };
  },
  methods: {
  }
};
</script>

<style lang="scss" scope>
  
.carousel-caption {
  top: 50%;
  margin-top: -50vW;
  .md-layout{
    width: auto;
    height: 100%;
  }
  h1 {
    margin-top: 40vW;
  }

  h4 {
    position: absolute;
    bottom: 50%;
    left: 0;
    right: 0;
    margin-bottom: -23vW;
  }
  b {
    font-size: 9rem;
  }
}
.md-card img {
    width: 100%;
    height: 100% !important;
    object-fit: cover;
  }
.VueCarousel-pagination {
  bottom: 50% !important;
  margin-bottom: -16vW !important;
}
.VueCarousel-slide {
  flex-basis: fit-content !important;
}
@media (max-width: 991px){
  .md-card {
    margin-top: 74px!important;
  }
}
</style>
